import { dom } from '@omegagrid/core';
import rp, { Application, ParsedComponentId, GridEditor } from '@reporting/rp-app-host';
import { Style as DefStyle } from "@reporting/rp-types/definition";
import { TableStyleEditor } from './components';
import { DictionaryGridEditorAdapter, StylesGridEditorAdapter, TableStylesGridEditorAdapter } from './adapters/general';

export const createTranslationsGrid = (app: Application, componentId: ParsedComponentId) => {
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = new DictionaryGridEditorAdapter();
	return component;
}

export const createStylesGrid = (app: Application, componentId: ParsedComponentId) => {
	const tableStyles = (componentId.ids[1] == 'table');
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = (tableStyles) ?
		new TableStylesGridEditorAdapter() :
		new StylesGridEditorAdapter();
	return component;
}

export const createTableStyleEditor = async (app: Application, componentId: ParsedComponentId) => {
	const idStyle = parseInt(componentId.ids[1]);
	const styleItem = await rp.ms('definition').get<DefStyle>(`styles/${idStyle}`);
	if (!styleItem) return null;
	return dom.createElement<TableStyleEditor>('rp-definition-table-style-editor', { styleItem });
}
